module.exports = __webpack_public_path__ + "static/media/candy-cane.d6ca35e9.svg";